import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { MultiselectBoundTemplate, TemplateWrapper } from "@ryde/controls";
import {
  convertGeoAreasGeomToGeoJson,
  IImportAreasProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { PolygonViewer } from "../../../map/polygon-viewer.map";
import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, DrawerFormWrapperStyled, FormFooter } from "../drawer";
import { useImportAreasDrawer } from "./use-import-areas";

export const ImportAreasDrawer: FC<
  IImportAreasProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, title, importType, onSelectPolygons }) => {
  const { t } = useTranslation();
  const { methods, isSaveDisabled, geoAreasGeom, onSaveClick } =
    useImportAreasDrawer();

  const handleSaveClick = useEvent(() => {
    onSaveClick({ importType, onSelectPolygons });
  });

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={title}
        onCloseDrawer={onCloseDrawer}
        Footer={
          <FormFooter
            cancelLabel={t("general.CLOSE")}
            onCancelClick={onCloseDrawer}
            onSaveClick={handleSaveClick}
            isSaveDisabled={isSaveDisabled}
          />
        }
      >
        <FormProvider {...methods}>
          <DrawerFormWrapperStyled>
            <TemplateWrapper>
              <MultiselectBoundTemplate
                name="geoAreasIds"
                formLabel={t("area.formLabel.areaIds2")}
                formAttributes={{
                  dropItemsSource: "geoArea",
                  dropItemsDisableAdd: true,
                }}
              />
            </TemplateWrapper>
            <TemplateWrapper>
              {geoAreasGeom.length > 0 && (
                <PolygonViewer
                  value={convertGeoAreasGeomToGeoJson(geoAreasGeom)}
                />
              )}
            </TemplateWrapper>
          </DrawerFormWrapperStyled>
        </FormProvider>
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
